import React from "react";

/**
 * @component BellOffSmallIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <BellOffSmallIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const BellOffSmallIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={12}
      height={12}
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="BellOffSmallIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        d="M8 11v1H4v-1h4zM1.414.707l9.9 9.9-.707.707L9.293 10H2V5c0-.665.162-1.292.45-1.843L.706 1.414l.707-.707zm1.591 4.117L3 5v4h5.293l-5.09-5.09c-.11.286-.18.593-.198.914zM7 0v1.126c1.725.444 3 2.01 3 3.874v2.9l-1-1V5a3 3 0 00-2.824-2.995L6 2c-.546 0-1.058.146-1.499.4l-.726-.725A3.98 3.98 0 015 1.126L5 0h2z"
        fillRule="evenodd"
      />
    </svg>
  )
);
BellOffSmallIcon.displayName = "BellOffSmallIcon";
export default BellOffSmallIcon;
